import React, { Component } from 'react';
import { Card, Checkbox, Col, Row } from 'antd';
import PropTypes from 'prop-types';

import FormInputNumber from 'components/FormInputNumber/FormInputNumber';

class SecurityDepositCard extends Component {
  state = {
    stripePreAuthDeposit: this.props.defaultValues.stripePreAuthDeposit || false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValues.stripePreAuthDeposit !== this.props.defaultValues.stripePreAuthDeposit) {
      this.setState({ stripePreAuthDeposit: this.props.defaultValues.stripePreAuthDeposit || false });
    }
  }

  handleToggle = e => {
    const checked = e.target.checked;
    this.setState({ stripePreAuthDeposit: checked });
    this.props.form.setFieldsValue({ stripePreAuthDeposit: checked });
  };

  render() {
    const { form, cardClassname, defaultValues } = this.props;
    const { stripePreAuthDeposit } = this.state;

    return (
      <Card title="Security Deposit" className={cardClassname}>
        <Row gutter={16}>
          <Col span={24}>
            {form.getFieldDecorator('stripePreAuthDeposit', {
              valuePropName: 'checked',
              initialValue: defaultValues.stripePreAuthDeposit || false
            })(<Checkbox onChange={this.handleToggle}>Enable Stripe pre-auth security deposit</Checkbox>)}
          </Col>
        </Row>
        {stripePreAuthDeposit && (
          <Row gutter={16} style={{ marginTop: 16 }}>
            <Col span={12}>
              <FormInputNumber
                form={form}
                name="securityDepositAmount"
                label="Default Security Deposit Amount"
                defaultValue={defaultValues.securityDepositAmount || 0}
                minValue={0}
                precision={2}
                size="large"
                placeholder="Enter deposit amount"
              />
            </Col>
          </Row>
        )}
      </Card>
    );
  }
}

SecurityDepositCard.propTypes = {
  form: PropTypes.object.isRequired,
  cardClassname: PropTypes.string.isRequired,
  defaultValues: PropTypes.object
};

SecurityDepositCard.defaultProps = {
  defaultValues: {}
};

export default SecurityDepositCard;
